export enum TeacherFeedbackResponseStatus {
  NEW,
  PENDING,
  VIEWED,
}



// WEBPACK FOOTER //
// ./ts/app/teacher-feedback/teacher-feedback-response-status/teacher-feedback-response-status.ts